import {
  COMPANIES_SET_LOADING,
  COMPANIES_SET_ERROR,
  COMPANIES_SET_COMPANIES,
  COMPANIES_SET_PAGINATION,
  COMPANIES_FETCH_COMPANIES,
  COMPANIES_CLEAR_ERROR,
  COMPANIES_GET_COMPANIES,
  COMPANIES_GET_PAGINATION,
  COMPANIES_GET_LOADING,
  COMPANIES_GET_ERROR,
  COMPANIES_RESEND_WELCOME_KIT
} from './types';
import { companyService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  companies: [],
  pagination: {
    page: 1,
    pages: null,
    size: 10,
    count: 0
  },
  ...createAsyncState(['fetchCompanies', 'resendWelcomeKit'])
};

const mutations = {
  ...createAsyncMutations(COMPANIES_SET_LOADING, COMPANIES_SET_ERROR),
  [COMPANIES_SET_COMPANIES](state, companies) {
    state.companies = companies;
  },
  [COMPANIES_SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  }
};

const actions = {
  async [COMPANIES_FETCH_COMPANIES](
    { commit },
    {
      holdingRut,
      holdingName,
      subholdingName,
      companyName,
      companyRut,
      employeeId,
      employeeStatus,
      page,
      size
    }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchCompanies',
      errorMessage: 'Ocurrió un error al obtener las empresas',
      asyncOperation: async () => {
        const hasPagination = size > 0;

        const query = {
          holdingRut,
          holdingName,
          subholdingName,
          companyName,
          companyRut,
          employeeId,
          employeeStatus
        };

        let companies;
        if (hasPagination) {
          const { rows, ...pagination } = await companyService.findAll({
            ...query,
            page,
            size
          });
          companies = rows;
          commit(COMPANIES_SET_PAGINATION, pagination);
        } else {
          companies = await companyService.findAll({
            ...query
          });
        }
        commit(COMPANIES_SET_COMPANIES, companies);
        return companies;
      },
      setLoading: COMPANIES_SET_LOADING,
      setError: COMPANIES_SET_ERROR
    });
  },

  async [COMPANIES_RESEND_WELCOME_KIT]({ commit }, { companyId }) {
    return handleAsyncAction({
      commit,
      actionType: 'resendWelcomeKit',
      errorMessage: 'Ocurrió un error al reenviar el kit de bienvenida',
      asyncOperation: async () => {
        await companyService.resendWelcomeKit(companyId);
        return true;
      },
      setLoading: COMPANIES_SET_LOADING,
      setError: COMPANIES_SET_ERROR
    });
  },

  [COMPANIES_CLEAR_ERROR]({ commit }, { type }) {
    commit(COMPANIES_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [COMPANIES_GET_COMPANIES]: (state) => state.companies,
  [COMPANIES_GET_PAGINATION]: (state) => state.pagination,
  [COMPANIES_GET_LOADING]: (state) => state.loading,
  [COMPANIES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
